/* eslint-disable no-unused-vars */

<template>
  <div class="login">
    <GoogleTranslate v-if="showLanguageDialog" />
    <p class="HardReloadButton" v-if="isMedall" @click="doHardReload">Hard Reload</p>
    <p
      class="HardReloadButton2"
      v-if="isMedall && isLocalHost"
      @click="redirectToAikenSuperAdmin"
    >
      Aiken Super Admin Login
    </p>

    <div class="medall_wrapper" v-if="isMedall">
  <div
  :style="{
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '590px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1rem',
  }"
>
  <img
    src="@/SVGs/medall DaignosticsAsset 1.svg"
    alt="Medall Logo"
    style="width: 240px; margin-left: 0"
  />

  <span style="font-size: 2rem; font-weight: 600; margin-bottom: 0.5rem">
    Login
  </span>

  <div style="width: 100%">
    <label style="display: block; font-weight: 500; margin-bottom: 0.2rem">
      Email*
    </label>
    <div style="position: relative">
      <input
        type="text"
        name="email"
        placeholder="Email"
        v-model="currentEmail"
        style="width: 100%; padding: 0.8rem 1rem;height: 30px; border: 1px solid #ccc; border-radius: 15px; font-size: 1rem"
      />
      <span
        v-if="cleartext"
        class="removeClick"
        @click="clearemail"
        style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer"
      >
        &times;
      </span>
    </div>
  </div>

  <div style="width: 100%">
    <label style="display: block; font-weight: 500; margin-bottom: 0.2rem">
      Password*
    </label>
    <div style="position: relative">
      <input
        id="myInput"
        type="password"
        placeholder="Password"
        v-model="currentPassword"
        show-password
        style="width: 100%; padding: 0.8rem 1rem;height: 30px; border: 1px solid #ccc; border-radius: 15px; font-size: 1rem"
      />
      <span
        v-if="clearPassword"
        class="removeClick"
        @click="togglePassword"
        style="position: absolute; top: 50%; right: 10px; transform: translateY(-50%); cursor: pointer; align-items: center;
    justify-content: center;">
        <i class="el-icon-view"></i>
      </span>
    </div>
  </div>

  <!-- <el-button
    type="text"
    @click="open"
    blur
    style="align-self: flex-start; padding-left: 0; font-weight: 600; margin-top: -0.5rem; color: black !important;"
  >
    Forgot Password
  </el-button> -->

  <el-button
    type="primary"
    @click="submitForm"
    round
    style="align-self: flex-start;color:black !important; background-color: #2196f3; padding: 0.7rem 2rem; border-radius: 25px; font-weight: 600"
  >
    Sign In
  </el-button>


  <div style="margin-top: 2rem; font-size: 0.85rem; color: #444;  margin-left: auto; display: flex; align-items: center">
    <span style="font-weight: 700;color: #003366;">Powered By</span>
    <img src="@/assets/Aikenist_med.png" alt="Aikenist" style="height: 50px; vertical-align: middle; margin-left: 5px" />
  </div>
</div>
</div>

    <div class="cic-shell" v-if="!isMedall">
      <div class="cic-hero">
        <div class="cic-carousel-container" v-if="isGdcrib">
          <el-carousel
            :interval="3000"
            arrow="always"
            height="100%"
            indicator-position="none"
          >
            <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
              <div class="carousel-content">
                <img :src="item.image" alt="Loading image" class="carousel-image" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <img
          v-else-if="isMediqas"
          class="cic-hero-bg-img"
          src="@/assets/medi_bg_full.jpg"
          alt="mediqas background"
        />
        <div v-else class="cic-hero-bg"></div>

        <div class="cic-hero-overlay"></div>

        <div class="cic-hero-content">
          <span class="cic-badge"><i class="el-icon-cpu"></i> NEXT-GEN AI DIAGNOSTIC SUITE</span>

          <div class="cic-hero-spacer"></div>

          <div>
            <h2 class="cic-hero-title">
              Clinical Intelligence for the<br />
              <span class="cic-hero-accent">Future of Radiology</span>
            </h2>

            <div class="cic-feature-grid" v-if="mfaRequired == false">
              <div class="cic-feature-card">
                <i class="el-icon-tickets"></i>
                <h4>Agentic PACS</h4>
                <p>Self-optimizing image archiving with AI-driven retrieval protocols.</p>
              </div>
              <div class="cic-feature-card">
                <i class="el-icon-share"></i>
                <h4>AI Enabled Workflow</h4>
                <p>Streamline diagnostic paths with autonomous triage and reporting assistance.</p>
              </div>
              <div class="cic-feature-card">
                <i class="el-icon-view"></i>
                <h4>Advanced Viewer</h4>
                <p>Next-gen DICOM visualization with sub-millimeter precision tools.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cic-panel">
        <div class="cic-panel-main">
          <div class="cic-panel-inner">
          <div class="cic-brand logos">
            <template
              v-if="loginClient !== 'gtr' && loginClient !== 'gtrt' && loginClient !== 'mediqas' && !isTopRad"
            >
              <span id="img-01">
                <img class="cic-aikenist-logo" src="@/assets/AikenistLogo.png" />
              </span>
            </template>
            <span v-if="loginClient === 'telerapp'" id="img-02">
              <img class="cic-client-logo" src="@/assets/telerapp_logo.png" />
            </span>
            <span v-if="loginClient === 'mediqas'" id="img-03">
              <img class="cic-client-logo" src="@/assets/mediqas_logo.png" />
            </span>
            <span
              v-if="loginClient === 'gtr' || loginClient === 'gtrt'"
              id="img-03"
            >
              <img class="cic-client-logo" src="@/assets/gtr_logo_no_bg.png" />
            </span>
            <span v-if="loginClient === 'chartwell'" id="img-03">
              <img class="cic-client-logo" src="@/assets/chartwell_logo.jpeg" />
            </span>
            <span v-if="isTopRad" id="img-03">
              <img class="cic-client-logo" src="@/assets/toprad_logo.png" style="width: 200px; height: auto;"/>
            </span>
          </div>

          <p class="cic-eyebrow">Precision Diagnostics Access Portal</p>
          <h1 class="cic-title">Secure Login</h1>

          <div v-if="mfaRequired == true" class="cic-form">
            <p class="cic-mfa-hint">
              We have shared a code to your registered email.
              <br />
              Please enter the code below to login.
            </p>
            <div class="cic-field">
              <label class="cic-label">Authentication Code</label>
              <div class="cic-input-wrap">
                <i class="el-icon-key cic-input-icon"></i>
                <input
                  type="text"
                  name="mfa_code"
                  placeholder="Enter code"
                  class="login-input cic-input"
                  v-model="mfaDetails.mfa_code"
                />
              </div>
            </div>
            <button class="cic-submit-btn" @click="validateMfaLogin">
              Sign In
            </button>
          </div>
          <div v-else class="cic-form">
            <div class="cic-field">
              <label class="cic-label">Email</label>
              <div class="cic-input-wrap">
                <i class="el-icon-message cic-input-icon"></i>
                <input
                  type="text"
                  name="email"
                  placeholder="dr.smith@hospital.org"
                  class="login-input cic-input"
                  v-model="currentEmail"
                />
                <span v-if="cleartext" class="removeClick cic-clear" @click="clearemail"
                  >&times;</span
                >
              </div>
            </div>
            <div class="cic-field">
              <label class="cic-label">Password</label>
              <div class="cic-input-wrap">
                <i class="el-icon-lock cic-input-icon"></i>
                <input
                  id="myInput"
                  type="password"
                  class="login-input cic-input"
                  placeholder="••••••••"
                  v-model="currentPassword"
                  show-password
                />
                <span v-if="clearPassword" class="removeClick cic-eye" @click="togglePassword">
                  <i class="el-icon-view"></i>
                </span>
              </div>
            </div>

            <div class="cic-row-between">
              <a class="cic-forgot-link" @click="open">Forgot Password?</a>
            </div>

            <button class="cic-submit-btn" @click="submitForm">
              Sign In
            </button>

            <p class="cic-signup-row">
              Don't have an account?
              <a
                class="cic-forgot-link"
                @click="$router.push({ name: 'Register' })"
                >Register</a
              >
            </p>
          </div>

          <div class="cic-divider"></div>

         <!--  <div class="cic-trust-badges">
            <span class="cic-trust-badge"><i class="el-icon-success"></i> HIPAA COMPLIANT</span>
            <span class="cic-trust-badge"><i class="el-icon-connection"></i> FHIR COMPLIANT</span>
          </div> -->

          <div class="poweredByAikenist cic-powered" v-if="loginClient == 'mediqas' || isTopRad">
            <span class="cic-powered-text">Powered by</span>
            <img style="width: 140px;" src="@/assets/AIkenist.png" />
          </div>
          </div>
        </div>

        <div class="cic-footer">
          <!-- Row 1: all links in one compact line -->
          <div class="cic-footer-links">
            <a class="cic-footer-link" href="https://www.aikenist.com/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
            <span class="cic-footer-dot">·</span>
            <a class="cic-footer-link" href="https://www.aikenist.com/legal" target="_blank" rel="noopener noreferrer">Terms</a>
            <span class="cic-footer-dot">·</span>
            <a class="cic-footer-link" href="https://www.aikenist.com/eula" target="_blank" rel="noopener noreferrer">License</a>
            <span class="cic-footer-dot">·</span>
            <span class="cic-footer-plain">HIPAA</span>
            <span class="cic-footer-dot">·</span>
            <span class="cic-footer-plain">DICOM</span>
            <span class="cic-footer-dot">·</span>
            <a class="cic-footer-link" href="https://www.aikenist.com/#contact" target="_blank" rel="noopener noreferrer">Contact</a>
            <span class="cic-footer-dot">·</span>
            <router-link class="cic-footer-link" to="/online-booking">Billing</router-link>
          </div>

          <!-- Row 2: copyright left, utilities right -->
          <div class="cic-footer-bottom">
            <span class="cic-footer-copy">© 2026 Aikenist Technologies Pvt. Ltd.</span>
            <div class="cic-utility-row">
              <span class="cic-utility-link" @click="doHardReload">
                <i class="el-icon-refresh"></i> Reload
              </span>
              <span class="cic-utility-link" v-if="isLocalHost" @click="redirectToAikenSuperAdmin">
                <i class="el-icon-key"></i> Admin
              </span>
              <el-tooltip class="item" effect="dark" content="Change Language" placement="top">
                <span class="cic-lang-link" @click="openLanguageDialog()">
                  <img src="@/assets/language.png" height="8px" /> English
                </span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postDataPost, validateMFA } from "@/services/login/postLogin";
import { Mixins } from "@/mixins/mixins.code.js";
import radConfig from "@/config/config";
import GoogleTranslate from "./../GoogleTranslate.vue";
import { get, set } from 'idb-keyval'
import { markAiLicenseAlertPending } from "@/utils/aiLicenseAlertFlag";
// Real `import`s, not require() - a literal require() call in a webpack5/ES
// module context skips Babel's default-export interop, so it resolves to the
// raw module namespace object ({__esModule, default}) instead of the URL
// string, and <img :src> handing that to setAttribute throws "Cannot convert
// object to primitive value". Confirmed via a paused breakpoint on the actual
// production build: key was "src", value was that exact Module object.
import bgSlider1 from "@/assets/bg_slider1.png";
import bgSlider2 from "@/assets/bg_slider2.png";

export default {
  components: {
    GoogleTranslate,
  },
  data() {
    return {
      isMediqas: false,
      isMedall: false,
      isTopRad: false,
      isGdcrib: false,
      isLocalHost: false,
      loginDetails: "",
      styleChanged: false,
      showLanguageDialog: false,
      loginClient: "",
      msg: [],
      cleartext: false,
      clearPassword: false,
      currentEmail: "",
      currentPassword: "",
      mfaRequired: false,

      posts: {
        password: "",
        email: "",
      },
      mfaDetails: {
        mfa_code: "",
        user_type: "",
        user_email: "",
      },
      carouselItems: [
        { image: bgSlider1 },
        { image: bgSlider2 },
        { image: bgSlider1 },
        { image: bgSlider2 },
      ],
    };
  },

  watch: {
    currentEmail(value) {
      if (value.length > 0) {
        this.cleartext = true;
      } else {
        this.cleartext = false;
      }
    },

     currentPassword(value) {
    if (value.length > 0) {
      this.clearPassword = true;

      this.currentPassword = value.replace(/\s+/g, "");
    } else {
      this.clearPassword = false;
    }
  },
  },

  mounted() {

    // if (window.location.href.includes("local"))
    if (window.location.href.includes("mediqasmed"))
    {
      document.title = "Mediqas";
      this.isMediqas = true;
    }
    if (window.location.href.includes("pacs.medallcorp.in"))
    {
      document.title = "Medall";
      this.isMedall = true;
    }
    if (window.location.href.includes("toprad"))
    {
      document.title = "TopRad";
      this.isTopRad = true;
    }

// ===================================================================== //

    if (window.location.href.includes("gdcrib")) {
      this.isGdcrib = true;
    } else if (window.location.href.includes("localhost")) {
      this.isLocalHost = true;
    }
  },

  beforeDestroy() {
    clearInterval(this.sliderInterval);
  },
  methods: {
    checkQuotaExceededError(e) {
      if (
        e.name === "QUOTA_EXCEEDED_ERR" ||
        e.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
        e.name === "QuotaExceededError" ||
        e.code === 22 ||
        e.code === 1014
      ) {
        this.doHardReload();
      }
    },
    redirectToAikenSuperAdmin() {
      this.$router.push({ name: "AikenSuperAdminLogin" });
    },
    redirectToLinkExpiry() {
      this.$router.push({ name: "LinkExpiry" });
    },
    validateMfaLogin() {
      this.mfaDetails.user_type = this.loginDetails.data.user_type;
      this.mfaDetails.user_email = this.currentEmail.trim().toLowerCase();

      validateMFA(this.mfaDetails).then((res) => {

        let loginStatus = res.data.status;
        let loginAccessToken = res.data.token;
        localStorage.setItem(
          "modify_report",
          res.data.is_allowed_to_modify_report
        );
        localStorage.setItem(
          "create_report",
          res.data.is_create_report_for_allotted_radio
        );

        if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "admin"
        ) {
          localStorage.setItem(
            "is_restrict_centres",
            this.loginDetails.data.is_restrict_centres
          );
          if (Object.prototype.hasOwnProperty.call(this.loginDetails.data, "is_settings_allowed")) localStorage.setItem("is_settings_allowed", this.loginDetails.data.is_settings_allowed);
          try {
            localStorage.setItem(
              "misAccess",
              this.loginDetails.data.mis.is_mis_access_allowed
            );
            localStorage.setItem(
              "InvoiceAccess",
              this.loginDetails.data.invoice.is_invoice_allowed
            );
            if (
              this.loginDetails.data.patient_billing &&
              "is_billing_allowed" in this.loginDetails.data.patient_billing
            ) {
              localStorage.setItem(
                "billingAccess",
                String(
                  this.loginDetails.data.patient_billing.is_billing_allowed === true
                )
              );
            } else {
              localStorage.removeItem("billingAccess");
            }
          } catch (e) {
            this.checkQuotaExceededError(e);
          }

          if (this.loginDetails.data.is_diag == false) {
            this.OpenLoader();
            try {
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "telerad");
              // Consumed once by AdminMaster, so the AI license notification
              // belongs to this login and not to every later page refresh
              // (which resumes the session further down without this flag).
              markAiLicenseAlertPending();
            } catch (e) {
              this.checkQuotaExceededError(e);
            }

            this.$router.push({
              name: "AdminMaster",
            });
            this.CloseLoader();
          } else if (this.loginDetails.data.is_diag == true) {
            this.OpenLoader();
            try {
              localStorage.setItem(
                "edit_patient_info",
                this.loginDetails.data.is_edit_patient_info_allowed
              );
              localStorage.setItem(
                "scan_download",
                this.loginDetails.data.is_download_of_scans_allowed
              );
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "diag");
            } catch (e) {
              this.checkQuotaExceededError(e);
            }
            this.$router.push({
              name: "DiagMaster",
            });
            this.CloseLoader();
          }
        } else if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "operator"
        ) {
          this.OpenLoader();
          try {
            localStorage.setItem("token", loginAccessToken);
            localStorage.setItem("loginAs", "operator");
          } catch (e) {
            this.checkQuotaExceededError(e);
          }
          this.$router.push({
            name: "Operator",
          });
          this.CloseLoader();
        } else if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "radiologist"
        ) {
          this.OpenLoader();
          try {
            localStorage.setItem("token", loginAccessToken);
            localStorage.setItem(
              "peerReviewAllowed",
              this.loginDetails.data.is_peer_review_allowed
            );
            localStorage.setItem("loginAs", "rad");
          } catch (e) {
            this.checkQuotaExceededError(e);
          }
          this.$router.push({
            name: "RadMaster",
          });
          this.CloseLoader();
        } else if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "physician"
        ) {
          this.OpenLoader();
          try {
            localStorage.setItem("token", loginAccessToken);
            localStorage.setItem("loginAs", "phys");
          } catch (e) {
            this.checkQuotaExceededError(e);
          }
          this.$router.push({
            name: "PhysMaster",
          });
          this.CloseLoader();
        } else if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "referrer" &&
          this.loginDetails.data.is_signed_up == false
        ) {
          this.OpenLoader();
          try {
            localStorage.setItem("token", loginAccessToken);
            localStorage.setItem("loginAs", "ref");
            localStorage.setItem("isSignedIn", "false");
            localStorage.setItem("display_viewer_only_after_approval", res.data.display_viewer_only_after_approval ?? false);
            localStorage.setItem("display_viewer_only_after_completion", res.data.display_viewer_only_after_completion ?? false);
            localStorage.setItem("display_viewer_only_after_final", res.data.display_viewer_only_after_final ?? false);
          } catch (e) {
            this.checkQuotaExceededError(e);
          }
          this.$router.push({
            name: "UpdateProfile",
          });
          this.CloseLoader();
        } else if (
          loginStatus == true &&
          this.loginDetails.data.user_type == "referrer" &&
          this.loginDetails.data.is_signed_up == true
        ) {
          this.OpenLoader();

          try {
            localStorage.setItem("token", loginAccessToken);
            localStorage.setItem("loginAs", "ref");
            localStorage.setItem("isSignedIn", "true");
            localStorage.setItem("display_viewer_only_after_approval", res.data.display_viewer_only_after_approval ?? false);
            localStorage.setItem("display_viewer_only_after_completion", res.data.display_viewer_only_after_completion ?? false);
            localStorage.setItem("display_viewer_only_after_final", res.data.display_viewer_only_after_final ?? false);
          } catch (e) {
            this.checkQuotaExceededError(e);
          }
          this.$router.push({
            name: "refMaster",
          });
          this.CloseLoader();
        } else {
          this.$notify.error({
            title: "Please enter valid credentials.",
            message: "",
            duration: "2500",
          });
        }
      });
    },
    observeStyleChange() {
      const targetNode = document.body;
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "style"
          ) {
            const topValue = targetNode.style.top;
            try {
              if (topValue === "0px") {
                this.styleChanged = false;

                localStorage.setItem("tooltipTransform", "false");
              } else {
                this.styleChanged = true;

                localStorage.setItem("tooltipTransform", "true");
              }
            } catch (e) {
              this.checkQuotaExceededError(e);
            }
          }
        });
      });

      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ["style"],
      });
    },
    openLanguageDialog() {
      this.showLanguageDialog = !this.showLanguageDialog;
       // Should print 'development' or 'production'
    },

    doHardReload() {
      localStorage.clear();
      sessionStorage.clear();
      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name);
        }
      });
      location.reload();
    },
    routeToUserPage() {
      this.$router.push({ name: "User_login" });
    },
    togglePassword() {
      var x = document.getElementById("myInput");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },

    clearemail() {

      this.currentEmail = "";
    },
    validateEmail(value) {
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        this.msg["email"] = "";
      } else {
        this.msg["email"] = "Invalid Email Address";
      }
    },



    async submitForm() {
      try {
        this.posts.email = this.currentEmail.trim().toLowerCase();
        this.posts.password = this.currentPassword;
        localStorage.setItem("currentEmail", this.currentEmail);
        postDataPost(this.posts).then(async (res) => {
          this.loginDetails = res;

          let loginStatus = res.data.status;
          let loginAccessToken = res.data.token;
          let allottement_allowed = res.data.is_allotment_allowed;
          let share_allowed = res.data.is_share_allowed;
          let pacs_type = res.data.pacs_type[0];
          let previousReportDeletionAllowed = res.data.is_previous_patient_report_deletion_allowed;
          let allowedToUseGAi = res?.data?.is_allowed_to_use_generative_ai ?? false;
          let allowedToUseQuillrAI = res?.data?.is_allowed_to_use_quillr_ai ?? false;
          let allowedToUsePC = res?.data?.is_allowed_to_use_proof_checking ?? false;
          let previousReportUploadAllowed = res.data.is_previous_patient_report_upload_allowed;
          let writingCommentsAllowed = res.data.is_writing_comments_allowed;
          let uploadOfScansAllowed = res.data.is_upload_of_scans_allowed;
          let adjustTatAllowed = res.data.is_allowed_to_bring_tat_within_cutoff;
          let misOnlyAllowed = res.data.is_show_only_mis;
          let telerad_id_list = res.data.telerad_id_list;
          let billingAllowed = res.data.is_billing_allowed;
          localStorage.setItem("allotment", allottement_allowed);
          localStorage.setItem("share_allowed", share_allowed);
          localStorage.setItem("pacs_type", pacs_type);
          localStorage.setItem("previousReportDeletion", previousReportDeletionAllowed);
          localStorage.setItem("allowedToUseGAi", allowedToUseGAi);
          localStorage.setItem("allowedToUseQuillrAI", allowedToUseQuillrAI);
          localStorage.setItem("allowedToUsePC", allowedToUsePC);
          localStorage.setItem("previousReportUpload", previousReportUploadAllowed);
          localStorage.setItem("writingCommentsAllowed", writingCommentsAllowed);
          localStorage.setItem("uploadOfScansAllowed", uploadOfScansAllowed);
          localStorage.setItem("adjustTatAllowed", adjustTatAllowed);
          localStorage.setItem("misOnlyAllowed", misOnlyAllowed);
          localStorage.setItem("viewers", JSON.stringify(res.data.viewers));
          localStorage.setItem("billingAllowed", billingAllowed);
          if (billingAllowed) {
            sessionStorage.setItem("userPassword", this.currentPassword);
          }
          if (res.data.viewer_options) {
            localStorage.setItem("viewer_options", JSON.stringify(res.data.viewer_options));
          }
          localStorage.setItem("is_viewer_download_allowed", res.data.is_viewer_download_allowed);
          localStorage.setItem("is_landing_page_download_allowed", res.data.is_landing_page_download_allowed);
          localStorage.setItem("mis", JSON.stringify(res.data.mis));

          await set('telerad_id_list', telerad_id_list)

          if (telerad_id_list.length > 0){
            await set("telerad_id", telerad_id_list[0])
            sessionStorage.setItem("telerad_id", telerad_id_list[0])
            localStorage.setItem("telerad_id", telerad_id_list[0])
          }

          localStorage.setItem(
            "modify_report",
            res.data.is_allowed_to_modify_report
          );
          localStorage.setItem(
            "invalidate_report",
            res.data.is_allowed_to_invalidate_report
          );
          localStorage.setItem(
            "complete_report",
            res.data.is_allowed_to_complete
          );
          localStorage.setItem(
            "reconsult_report",
            res.data.is_allowed_to_reconsult_report
          );
          localStorage.setItem(
            "create_report",
            res.data.is_create_report_for_allotted_radio
          );

          radConfig.allottement_status = res.data.is_allotment_allowed;

          if (res.data.is_blocked == true) {
            this.$notify.error({
              title: "User is Blocked.",
              message: "Please contact your admin for further details.",
              duration: "2500",
            });
            return;
          }


          localStorage.setItem("UserName", res.data.name);
          if (
            res.data.telerad_security_policy.idle_session_timeout.is_required ==
            true
          ) {
            localStorage.setItem(
              "inactivityTimeout",
              res.data.telerad_security_policy.idle_session_timeout
                .timeout_minutes *
                60 *
                1000
            );
          } else {
            localStorage.setItem("inactivityTimeout", Infinity);
          }

          let name = this.currentEmail.substring(
            0,
            this.currentEmail.lastIndexOf("@")
          );
          localStorage.setItem("LoginName", name);

          // **********************  MFA Login ************************ //

          if (res.data.is_mfa_required == true) {
            this.mfaRequired = true;
            this.mfa_code = "";

          } else {
            if (loginStatus == true && res.data.user_type == "admin") {
              localStorage.setItem(
                "is_restrict_centres",
                res.data.is_restrict_centres
              );
              if (Object.prototype.hasOwnProperty.call(res.data, "is_settings_allowed")) localStorage.setItem("is_settings_allowed", res.data.is_settings_allowed);
              localStorage.setItem(
                "is_utility_allowed",
                res.data.is_utility_allowed
              );
              localStorage.setItem(
                "is_display_only_completed_reports",
                res.data.is_display_only_completed_reports
              );
              localStorage.setItem(
                "misAccess",
                res.data.mis.is_mis_access_allowed
              );
              localStorage.setItem(
                "InvoiceAccess",
                res.data.invoice.is_invoice_allowed
              );
              if (
                res.data.patient_billing &&
                "is_billing_allowed" in res.data.patient_billing
              ) {
                localStorage.setItem(
                  "billingAccess",
                  String(res.data.patient_billing.is_billing_allowed === true)
                );
              } else {
                localStorage.removeItem("billingAccess");
              }

              if (res.data.is_diag == false) {
                this.OpenLoader();
                localStorage.setItem("token", loginAccessToken);
                localStorage.setItem("loginAs", "telerad");
                // See the non-MFA branch above: marks a fresh login, not a reload.
                markAiLicenseAlertPending();
                localStorage.setItem(
                  "scan_download",
                  this.loginDetails.data.is_download_of_scans_allowed
                );
                localStorage.setItem(
                  "edit_patient_info",
                  this.loginDetails.data.is_edit_patient_info_allowed
                );
                localStorage.setItem(
                  "rad_group_required",
                  this.loginDetails.data.is_rad_grouping_required
                );
                localStorage.setItem(
                  "adLoginEnabled",
                  this.loginDetails.data.is_ad_login_enabled
                );
                localStorage.setItem(
                  "manage_order_from_ris",
                  this.loginDetails.data.should_manage_order_details_from_ris
                );
                localStorage.setItem(
                  "order_status_mapping",
                  JSON.stringify(this.loginDetails.data.order_status_mapping)
                );
                this.$router.push({
                  name: "AdminMaster",
                });
                this.CloseLoader();
              } else if (res.data.is_diag == true) {
                this.OpenLoader();
                localStorage.setItem(
                  "edit_patient_info",
                  this.loginDetails.data.is_edit_patient_info_allowed
                );
                localStorage.setItem(
                  "scan_download",
                  this.loginDetails.data.is_download_of_scans_allowed
                );
                localStorage.setItem("token", loginAccessToken);
                localStorage.setItem(
                  "manage_order_from_ris",
                  this.loginDetails.data.should_manage_order_details_from_ris
                );
                localStorage.setItem(
                  "order_status_mapping",
                  JSON.stringify(this.loginDetails.data.order_status_mapping)
                );
                localStorage.setItem("loginAs", "diag");
                this.$router.push({
                  name: "DiagMaster",
                  // name: "DiagCenter",
                });
                this.CloseLoader();
              }
            } else if (
              loginStatus == true &&
              res.data.user_type == "operator"
            ) {
              this.OpenLoader();
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "operator");
              this.$router.push({
                name: "Operator",
              });
              this.CloseLoader();
            } else if (
              loginStatus == true &&
              res.data.user_type == "radiologist"
            ) {
              this.OpenLoader();
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem(
                "peerReviewAllowed",
                res.data.is_peer_review_allowed
              );
              localStorage.setItem("loginAs", "rad");
              localStorage.setItem("AllotmentAllowed", res.data.is_allowed_to_allot);
              localStorage.setItem("ApproveReport", res.data.is_allowed_to_approve);
              localStorage.setItem("CompleteReport", res.data.is_allowed_to_complete);
              localStorage.setItem("ShareScan", res.data.is_share_allowed);
              localStorage.setItem("DownloadScans", res.data.is_download_of_scans_allowed);
              localStorage.setItem("EditPatient", res.data.is_edit_patient_info_allowed);
              localStorage.setItem("ViewAlloted", res.data.is_allowed_to_view_allotment);
              localStorage.setItem("ViewDiagCentre", res.data.is_allowed_to_view_diag);
              localStorage.setItem("write_final", res.data.is_allowed_to_write_final);
              localStorage.setItem("SignAndApprove", res.data.is_allowed_to_sign_and_approve);
              localStorage.setItem(
                  "manage_order_from_ris",
                  this.loginDetails.data.should_manage_order_details_from_ris
                );
                localStorage.setItem(
                  "order_status_mapping",
                  JSON.stringify(this.loginDetails.data.order_status_mapping)
                );
              this.$router.push({
                name: "RadMaster",
              });
              this.CloseLoader();
            } else if (
              loginStatus == true &&
              res.data.user_type == "physician"
            ) {
              this.OpenLoader();
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "phys");
              this.$router.push({
                name: "PhysMaster",
              });
              this.CloseLoader();
            } else if (
              loginStatus == true &&
              res.data.user_type == "referrer" &&
              res.data.is_signed_up == false
            ) {
              this.OpenLoader();
              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "ref");
              localStorage.setItem("isSignedIn", "false");
              localStorage.setItem("display_viewer_only_after_approval", res.data.display_viewer_only_after_approval ?? false);
              localStorage.setItem("display_viewer_only_after_completion", res.data.display_viewer_only_after_completion ?? false);
              localStorage.setItem("display_viewer_only_after_final", res.data.display_viewer_only_after_final ?? false);
              this.$router.push({
                name: "UpdateProfile",
              });
              this.CloseLoader();
            } else if (
              loginStatus == true &&
              res.data.user_type == "referrer" &&
              res.data.is_signed_up == true
            ) {
              this.OpenLoader();

              localStorage.setItem("token", loginAccessToken);
              localStorage.setItem("loginAs", "ref");
              localStorage.setItem("isSignedIn", "true");
              localStorage.setItem("display_viewer_only_after_approval", res.data.display_viewer_only_after_approval ?? false);
              localStorage.setItem("display_viewer_only_after_completion", res.data.display_viewer_only_after_completion ?? false);
              localStorage.setItem("display_viewer_only_after_final", res.data.display_viewer_only_after_final ?? false);
              this.$router.push({
                name: "refMaster",
              });
              this.CloseLoader();
            } else {
              this.$notify.error({
                title: "Please enter valid credentials.",
                message: "",
                duration: "2500",
              });
            }
          }
        }).catch(() => {
          this.$notify.error({
            title: "Login failed.",
            message: "Please check your credentials or try again later.",
            duration: "2500",
          });
        });
      } catch (e) {
        this.checkQuotaExceededError(e);
      }
    },

    open() {
      this.$router.push({
        name: "ForgotPassword",
      });
    },
  },

  created() {
    let currVersion = `${radConfig.version}`;
    let prevVersion = localStorage.getItem("software_version");

    if (prevVersion == null || prevVersion == undefined || prevVersion == "") {

      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name);
        }
      });
      try {
        localStorage.setItem("software_version", currVersion);
      } catch (e) {
        this.checkQuotaExceededError(e);
      }
      location.reload();
    }

    if (currVersion == prevVersion) {

    } else {
      caches.keys().then(function (names) {
        for (let name of names) {
          caches.delete(name);
        }
      });
      try {
        localStorage.setItem("software_version", currVersion);
      } catch (e) {
        this.checkQuotaExceededError(e);
      }
      location.reload();

    }

    if (localStorage.token != null) {
      if (localStorage.loginAs == "telerad") {
        this.$router.push({
          name: "AdminMaster",
        });
      } else if (localStorage.loginAs == "diag") {
        this.$router.push({
          name: "DiagMaster",
        });
      } else if (localStorage.loginAs == "rad") {
        this.$router.push({
          name: "RadMaster",
        });
      } else if (localStorage.loginAs == "phys") {
        this.$router.push({
          name: "PhysMaster",
        });
      } else if (
        localStorage.loginAs == "ref" &&
        localStorage.isSignedIn == "true"
      ) {
        this.$router.push({
          name: "refMaster",
        });
      }
    }

    this.loginClient = `${radConfig.client}`;
  },

  mixins: [Mixins],
};
</script>

<style>
body{
  padding: 0px;
  margin: 0px;
}
.el-carousel {
  position: relative;
  margin-left: 10px;
}

button.el-carousel__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 24px;
}

button.el-carousel__arrow.el-carousel__arrow--left {
  left: 0;
  margin-left: 10px;
}

button.el-carousel__arrow.el-carousel__arrow--right {
  right: 0;
  margin-right: 10px;
}
.carousel-container {
  flex: 1;
  max-width: 66.6%;
  background-color: white;
}

.poweredByAikenist {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: flex-start;
    font-weight: 600;
    font-style: italic;
    margin-top: 50px;
    font-size: 20px;
}

.carousel-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.carousel-image {
  height: 100%;
  width: auto;
  object-fit: contain;
}

.center-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin-top: 20px; */
  text-align: center;
}

.center-logo img {
  width: 100px;
  height: auto;
}

.login {
  position: relative;
}

.login-input {
  display: inline-block;
  height: 40px;
  width: 90%;
  font-size: 15px;
  color: #666666;
  text-indent: 8px;
  border: 1px solid #2d2d2d;
  margin: 15px !important;
  border: 0px solid #2d2d2d;
  border-bottom: 1px solid #3d3131;
}

.text-field-position {
  position: relative;
}

.text-field-position span {
  position: absolute;
  right: 2em;
  top: 0.5em;
  bottom: 0;
  line-height: 40px;
}

.languageButton:hover {
  cursor: pointer;
  scale: 1.05;
}
.languageButton {
  position: fixed;
  bottom: 10px;
  right: 5px;
  z-index: 1;
  cursor: pointer;
}

.goog-te-gadget {
  font-size: 10px !important;
}

.bg {
  background-image: url("../assets/bg.jpeg");
  height: 100vh;
  width: 70vw;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.medall_wrapper {
  background-image: url("../assets/medall_bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.medi_logo {
  width: 180px;
  margin-bottom: 1rem;
}

.login-input {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
}

.text-field-position {
  position: relative;
  width: 100%;
}

.medi_bg {
  width: 70vw;
  height: auto;
  margin: auto 0;
}

.login-div {
  position: absolute;
  padding: 10px;
  top: 0%;
  right: 0%;
  font-size: 25px;
  background-color: #fafafa;
  font-family: "Roboto";
  height: 100vh;
  width: 33vw;
  display: inline-block;
}

.UserLoginLink {
  position: fixed;
  margin: 20px;
  cursor: pointer;
  text-decoration: underline;
  z-index: 99;
}

.HardReloadButton {
  position: fixed;
  cursor: pointer;
  text-decoration: underline;
  z-index: 99;
  bottom: 5px;
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  color: darkcyan;
}
.HardReloadButton2 {
  position: fixed;
  cursor: pointer;
  text-decoration: underline;
  z-index: 99;
  bottom: 5px;
  font-size: 14px;
  font-weight: 600;
  margin-left: 100px;
  color: darkcyan;
}
.HardReloadButton3 {
  position: fixed;
  cursor: pointer;
  text-decoration: underline;
  z-index: 99;
  bottom: 5px;
  font-size: 14px;
  font-weight: 600;
  margin-left: 400px;
  color: darkcyan;
}

.logos {
  display: flex;
  flex-direction: row;
  height: 20%;
  align-items: center;
  justify-content: space-between;
}

i.el-icon-view {
  font-size: 14px !important;
  /* margin: 0px !important; */
  padding: 0px !important;
  color: black !important;
}

#img-01 {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 40% !important;
  height: 40% !important;
}

#img-01::before {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 40%;
  height: 50%;
}

#img-03 {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  height: 45%;
}

#img-03::before {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  height: 45%;
}

#img-02 {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  width: 10%;
  height: auto;
  justify-content: flex-end;
}

#img-02::before {
  margin-top: 30px;
  display: flex;
  flex-direction: row-reverse;
  width: 10%;
  height: auto;
  justify-content: flex-end;
}

.rad {
  color: black !important;
  font-family: "Roboto";
  font-weight: 700;
  margin-top: 12%;
  margin-bottom: 10%;
  padding: 1%;
}

.el-icon-user-solid {
  color: black !important;
}

.el-icon-user-solid:before {
  color: black !important;
}

.inner {
  margin: 1% !important;
  display: inline-block;
  justify-content: center;
}

/* .el-notification {
  background-color: rgba(218, 122, 122, 0.9) !important;
  color: black !important;
} */

.inner_login-div {
  margin-top: 30px;
  margin-bottom: 0px;
  width: 80%;
  margin-left: 10% !important;
  padding: 2px;
}

.submitMfaCode {
  color: #fff !important;
  background-color: #409eff !important;
  /* border-color: #409eff !important; */
  border: none !important;
  font-size: 16px !important;
  border-radius: 20px !important;
  padding: 5px 10px !important;
  transition: 1.1s !important;
  cursor: pointer;
}

.login .el-button.el-button--primary {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
  margin: 3px !important;
  margin-bottom: 8% !important;
  transition: 1.1s !important;
  font-weight: 900 !important;
  margin-left: 40% !important;
  font-size: 16px !important;
  border-radius: 20px !important;
  padding: 12px 23px !important;
}

.login .el-button.el-button--info {
  color: #fff !important;
  background-color: #1e75b3 !important;
  border-color: #1e75b3 !important;
  margin: 5px !important;
  transition: 1.1s !important;
  font-weight: 700 !important;
  font-size: 16px !important;
  margin-left: 27% !important;
  margin-top: 20% !important;
  padding: 5px !important;
  height: 4.5vh !important;
  width: 8vw !important;
  text-align: center !important;
  border-radius: 30px !important;
}

.login .el-button.el-button--info:hover {
  background-color: #398ccc !important;
  border-color: #398ccc !important;
  color: #fff !important;
}

.login .el-button--text {
  color: #0080ff !important;
  margin-top: 1% !important;
}

@media only screen and (max-width: 1500px) {
  .login .el-button.el-button--info {
    margin: 5px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    margin-left: 20% !important;
    padding: 8px !important;
    height: 5vh !important;
    width: 9vw !important;
    text-align: center !important;
    border-radius: 30px !important;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 20%;
    align-items: center;
    justify-content: space-between;
  }

  #img-01::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 45%;
  }

  #img-03::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }

  #img-01 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 45%;
  }

  #img-03 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }
}

@media only screen and (max-height: 800px) and (min-width: 1300px) {
  .login-div {
    position: absolute;
    padding: 10px;
    top: 0%;
    right: 0%;
    font-size: 25px;
    background-color: #fafafa;
    font-family: "Roboto";
    height: 100%;
    width: 33vw;
    display: inline-block;
  }

  #img-01::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
  }

  #img-01 {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
  }

  #img-03::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
  }

  #img-03 {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
  }

  #img-02::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }

  #img-02 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }

  .rad {
    font-family: "Roboto";
    font-weight: 700;
    margin-top: 12%;
    margin-bottom: 10%;
    padding: 1%;
  }

  .el-radio {
    margin-left: 30;
    display: inline !important;
    cursor: pointer !important;
    margin: 5% !important;
    margin-left: 10% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: larger !important;
    padding: 5% !important;
    margin-right: 30px !important;
    justify-content: center !important;
  }

  .login-input {
    display: inline-block;
    height: 30px;
    width: 80%;
    font-size: 15px;
    color: #666666;
    margin: 15px !important;
    text-indent: 8px;
    border: 0px solid #2d2d2d;
    border-bottom: 1px solid #3d3131;
  }

  .inner_login-div {
    margin-top: 30px;
    margin-bottom: 0px;
    width: 80%;
    margin-left: 10% !important;
    padding: 2px;
  }

  .login .el-button.el-button--primary {
    color: #fff !important;
    background-color: #409eff !important;
    border-color: #409eff !important;
    margin: 3px !important;
    margin-bottom: 3% !important;
    font-weight: 600 !important;
    margin-left: 40% !important;
    font-size: 16px !important;
    border-radius: 20px !important;
    padding: 12px 23px !important;
  }

  .login .el-button.el-button--info {
    margin: 5px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    margin-left: 20% !important;
    padding: 8px !important;
    height: 5.5vh !important;
    width: 9vw !important;
    text-align: center !important;
    border-radius: 30px !important;
    justify-content: center;
  }
}

@media only screen and (max-height: 700px) and (min-width: 1300px) {
  .login-div {
    position: absolute;
    padding: 10px;
    top: 0%;
    right: 0%;
    font-size: 25px;
    background-color: #fafafa;
    font-family: "Roboto";
    height: 100%;
    width: 33vw;
    display: inline-block;
  }

  .rad {
    font-family: "Roboto";
    font-weight: 700;
    margin-top: 10%;
    margin-bottom: 8%;
    padding: 1%;
  }

  .el-radio {
    margin-left: 30;
    display: inline !important;
    cursor: pointer !important;
    margin: 4% !important;
    margin-left: 10% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: larger !important;
    padding: 5% !important;
    margin-right: 30px !important;
    justify-content: center !important;
  }

  .inner_login-div {
    margin-top: 30px;
    margin-bottom: 0px;
    width: 80%;
    margin-left: 10% !important;
    padding: 2px;
  }

  /*
  .el-input__inner {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
    border-radius: 0px !important;
    background-color: #fafafa !important;
    border: 1px solid #3a3a3b !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    color: #080808 !important;
    font-size: large !important;
  } */

  .login .el-button.el-button--primary {
    color: #fff !important;
    background-color: #409eff !important;
    border-color: #409eff !important;
    margin: 3px !important;
    margin-bottom: 3% !important;
    font-weight: 600 !important;
    margin-left: 40% !important;
    font-size: 16px !important;
    border-radius: 20px !important;
    padding: 12px 23px !important;
  }

  .login .el-button.el-button--info {
    margin: 5px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 20% !important;
    padding: 2px !important;
    height: 5vh !important;
    width: 9vw !important;
    text-align: center !important;
    border-radius: 30px !important;
  }
}

@media only screen and (max-height: 800px) {
  .logos {
    display: flex;
    flex-direction: row;
    height: 20%;
    align-items: center;
    justify-content: space-between;
  }

  #img-01::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 50%;
  }

  #img-03::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 50%;
  }

  #img-02::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
    height: 20%;
  }

  #img-01 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 50%;
  }

  #img-03 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: 50%;
  }

  #img-02 {
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
    height: 20%;
  }
}

@media only screen and (max-width: 1300px) {
  .login .el-button.el-button--info {
    margin: 5px !important;
    transition: 1.1s !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    margin-left: 20% !important;
    padding: 8px !important;
    height: 5vh !important;
    width: 9vw !important;
    text-align: center !important;
    border-radius: 30px !important;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 20%;
    align-items: center;
    justify-content: space-between;
  }

  .text-field-position span {
    position: absolute;
    right: 1.5em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }

  #img-01::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 40%;
  }

  #img-03::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 40%;
  }

  #img-02::before {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }

  #img-01 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 40%;
  }

  #img-03 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 40%;
  }
  #toprad-img {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 40%;
    height: 40%;
  }

  #img-02 {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    width: 10%;
    height: 20%;
    justify-content: flex-end;
  }
}

@media only screen and (max-width: 1050px) {
  .bg {
    background-image: url("../assets/bg.jpeg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .medi_bg {
    background-image: url("../assets/medi_bg.jpg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-div {
    position: absolute;
    padding: 4px;
    margin-top: 35%;
    margin-right: 3vw;
    right: 5%;
    font-size: 20px;
    background-color: rgba(250, 250, 250, 0.9);
    font-family: "Roboto";
    height: inherit;
    width: 85vw;
    display: inline-block;
    border-radius: 8px;
  }

  .text-field-position span {
    position: absolute;
    right: 4em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 15vh;
    align-items: center;
    justify-content: flex-start;
  }

  #img-01::before {
    display: flex;
    flex-direction: row;
    height: 60%;
  }

  #img-02::before {
    display: flex;
    flex-direction: row-reverse;
    height: 40%;
  }

  #img-01 {
    display: flex;
    flex-direction: row;
    height: 60%;
  }

  #img-02 {
    display: flex;
    flex-direction: row-reverse;
    height: 40%;
  }

  .rad {
    font-weight: 600;
    font-size: 17px;
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 1%;
  }

  .el-radio {
    display: inline !important;
    cursor: pointer !important;
    margin: 7% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: 20px !important;
    padding: 3% !important;
    margin-right: 15px !important;
    justify-content: center !important;
  }

  /*
  .el-input__icon {
    width: 44px !important;
    text-align: justify !important;
    transition: all 0.3s !important;
    line-height: 65px !important;
    margin-right: 2px !important;
  } */

  .login .el-button.el-button--primary {
    margin: 0px !important;
    margin-bottom: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 37% !important;
    padding: 11px !important;
  }

  .login .el-button.el-button--info {
    margin-top: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 10px !important;
    margin-left: 20% !important;
    padding: 8px !important;
    height: 5vh !important;
    width: 10vw !important;
    text-align: center !important;
    border-radius: 30px !important;
    background-color: #1e75b3 !important;
  }

  .login .el-button--text {
    color: #0080ff !important;
    margin-top: 2% !important;
  }
}

@media only screen and (max-width: 900px) {
  .bg {
    background-image: url("../assets/bg.jpeg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .medi_bg {
    background-image: url("../assets/medi_bg.jpg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-div {
    position: absolute;
    padding: 4px;
    margin-top: 25%;
    margin-right: 3vw;
    right: 5%;
    font-size: 20px;
    background-color: rgba(250, 250, 250, 0.9);
    font-family: "Roboto";
    height: inherit;
    width: 85vw;
    display: inline-block;
    border-radius: 8px;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 15vh;
    align-items: center;
    justify-content: flex-start;
  }

  #img-01::before {
    display: flex;
    flex-direction: row;
    height: 60%;
  }

  #img-02::before {
    display: flex;
    flex-direction: row-reverse;
    height: 40%;
  }

  #img-01 {
    display: flex;
    flex-direction: row;
    height: 60%;
  }

  #img-02 {
    display: flex;
    flex-direction: row-reverse;
    height: 40%;
  }

  .rad {
    font-weight: 600;
    font-size: 17px;
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 1%;
  }

  .el-radio {
    display: inline !important;
    cursor: pointer !important;
    margin: 7% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: 20px !important;
    padding: 3% !important;
    margin-right: 15px !important;
    justify-content: center !important;
  }

  /* .el-input__inner {
    margin-left: 10% !important;
    margin-top: 4% !important;
    margin-bottom: 1px !important;
    border-radius: 0px !important;
    background-color: rgba(250, 250, 250, 0.5) !important;
    border: 1px solid #3a3a3b !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    color: #080808 !important;
    font-size: 13px !important;
    width: 80% !important;
  }

  .el-input__icon {
    width: 44px !important;
    text-align: justify !important;
    transition: all 0.3s !important;
    line-height: 65px !important;
    margin-right: 2px !important;
  } */

  .login .el-button.el-button--primary {
    margin: 0px !important;
    margin-bottom: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 37% !important;
    padding: 11px !important;
  }

  .login .el-button.el-button--info {
    margin-top: 0px !important;
    transition: 1.1s !important;
    font-weight: 100 !important;
    font-size: 8px !important;
    margin-left: 20% !important;
    padding: 4px !important;
    height: 4vh !important;
    width: 10vw !important;
    text-align: center !important;
    border-radius: 30px !important;
    background-color: #1e75b3 !important;
  }

  .login .el-button--text {
    color: #0080ff !important;
    margin-top: 2% !important;
  }
}

@media only screen and (max-width: 700px) {
  .bg {
    background-image: url("../assets/bg.jpeg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .medi_bg {
    background-image: url("../assets/medi_bg.jpg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .login-div {
    position: absolute;
    padding: 4px;
    margin-top: 35%;
    margin-right: 3vw;
    right: 5%;
    font-size: 20px;
    background-color: rgba(250, 250, 250, 0.9);
    font-family: "Roboto";
    height: inherit;
    width: 85vw;
    display: inline-block;
    border-radius: 8px;
  }

  .text-field-position span {
    position: absolute;
    right: 5.5em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }

  .login-input {
    display: inline-block;
    height: 30px;
    width: 80%;
    font-size: 15px;
    color: #666666;
    margin: 15px !important;
    text-indent: 8px;
    border: 0px solid #2d2d2d;
    border-bottom: 1px solid #3d3131;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 15vh;
    align-items: center;
    justify-content: flex-start;
  }

  #img-01::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
    height: 30%;
  }

  #img-01 {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02 {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
    height: 30%;
  }

  .rad {
    font-weight: 600;
    font-size: 17px;
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 1%;
  }

  .el-radio {
    display: inline !important;
    cursor: pointer !important;
    margin: 7% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: 20px !important;
    padding: 3% !important;
    margin-right: 15px !important;
    justify-content: center !important;
  }

  /* .el-input__inner {
    margin-left: 10% !important;
    margin-top: 4% !important;
    margin-bottom: 1px !important;
    border-radius: 0px !important;
    background-color: rgba(250, 250, 250, 0.5) !important;
    border: 1px solid #3a3a3b !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    color: #080808 !important;
    font-size: 13px !important;
    width: 80% !important;
  }

  .el-input__icon {
    width: 44px !important;
    text-align: justify !important;
    transition: all 0.3s !important;
    line-height: 65px !important;
    margin-right: 2px !important;
  } */

  .login .el-button.el-button--primary {
    margin: 0px !important;
    margin-bottom: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 37% !important;
    padding: 11px !important;
  }

  .login .el-button.el-button--info {
    margin-top: 0px !important;
    transition: 1.1s !important;
    font-weight: 500 !important;
    font-size: 9px !important;
    margin-left: 20% !important;
    padding: 0px !important;
    height: 47% !important;
    width: 80% !important;
    text-align: center !important;
    border-radius: 30px !important;
    background-color: #1e75b3 !important;
  }

  .login .el-button--text {
    color: #0080ff !important;
    margin-top: 2% !important;
  }
}

@media only screen and (max-width: 600px) {
  .text-field-position span {
    position: absolute;
    right: 5em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }
}

@media only screen and (max-width: 500px) {
  .text-field-position span {
    position: absolute;
    right: 4em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }
}

@media only screen and (max-width: 400px) {
  .bg {
    background-image: url("../assets/bg.jpeg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .medi_bg {
    background-image: url("../assets/medi_bg.jpg");
    height: 100vh;
    width: 100vw;
    position: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .text-field-position span {
    position: absolute;
    right: 3em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }

  .login-div {
    position: absolute;
    padding: 4px;
    margin-top: 35%;
    margin-right: 3vw;
    right: 5%;
    font-size: 20px;
    background-color: rgba(250, 250, 250, 0.9);
    font-family: "Roboto";
    height: inherit;
    width: 85vw;
    display: inline-block;
    border-radius: 8px;
  }

  .login-input {
    display: inline-block;
    height: 30px;
    width: 80%;
    font-size: 15px;
    color: #666666;
    margin: 15px !important;
    text-indent: 8px;
    border: 0px solid #2d2d2d;
    border-bottom: 1px solid #3d3131;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 15vh;
    align-items: center;
    justify-content: flex-start;
  }

  #img-01::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02::before {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
    height: 25%;
  }

  #img-01 {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02 {
    margin-top: 20px;
    display: flex;
    flex-direction: row-reverse;
    height: 25%;
  }

  .rad {
    font-weight: 600;
    font-size: 17px;
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 1%;
  }

  .el-radio {
    display: inline !important;
    cursor: pointer !important;
    margin: 7% !important;
    font-family: "Roboto" !important;
    font-weight: 900 !important;
    font-size: 20px !important;
    padding: 3% !important;
    margin-right: 15px !important;
    justify-content: center !important;
  }

  /* .el-input__inner {
    margin-left: 5% !important;
    margin-top: 4% !important;
    margin-bottom: 1px !important;
    border-radius: 0px !important;
    background-color: rgba(250, 250, 250, 0.5) !important;
    border: 1px solid #3a3a3b !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    color: #080808 !important;
    font-size: 11px !important;
    width: 90% !important;
  } */

  .login .el-button.el-button--primary {
    margin: 0px !important;
    margin-bottom: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 37% !important;
    padding: 11px !important;
  }

  .login .el-button.el-button--info {
    margin-top: 0px !important;
    transition: 1.1s !important;
    font-weight: 550 !important;
    font-size: 9px !important;
    margin-left: 17% !important;
    padding: 0px !important;
    height: 47% !important;
    width: 80% !important;
    text-align: center !important;
    border-radius: 30px !important;
    background-color: #1e75b3 !important;
  }

  .login .el-button--text {
    color: #0080ff !important;
    margin-top: 2% !important;
  }
}

@media only screen and (max-width: 300px) {
  .bg {
    background-image: url("../assets/bg.jpeg");
    height: 100vh;
    width: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .medi_bg {
    background-image: url("../assets/medi_bg.jpg");
    height: 100vh;
    width: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .text-field-position span {
    position: absolute;
    right: 2em;
    top: 0.5em;
    bottom: 0;
    line-height: 40px;
  }

  .login-div {
    position: absolute;
    padding: 4px;
    margin-top: 35%;
    margin-right: 3vw;
    right: 5%;
    font-size: 20px;
    background-color: rgba(250, 250, 250, 0.9);
    font-family: "Roboto";
    height: inherit;
    width: 85vw;
    display: inline-block;
    border-radius: 8px;
  }

  .logos {
    display: flex;
    flex-direction: row;
    height: 15vh;
    align-items: center;
    justify-content: flex-start;
  }

  .login-input {
    display: inline-block;
    height: 30px;
    width: 80%;
    font-size: 15px;
    color: #666666;
    margin: 15px !important;
    text-indent: 8px;
    border: 0px solid #2d2d2d;
    border-bottom: 1px solid #3d3131;
  }

  #img-01::before {
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02::before {
    display: flex;
    flex-direction: row-reverse;
    height: 20%;
  }

  #img-01 {
    display: flex;
    flex-direction: row;
    height: 40%;
  }

  #img-02 {
    display: flex;
    flex-direction: row-reverse;
    height: 20%;
  }

  .rad {
    font-weight: 600;
    font-size: 17px;
    margin-top: 2px;
    margin-bottom: 5px;
    padding: 1%;
  }

  .el-radio {
    display: inline !important;
    cursor: pointer !important;
    margin: 4% !important;
    font-family: "Roboto" !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    padding: 3% !important;
    margin-right: 15px !important;
    justify-content: center !important;
  }

  /* .el-input__inner {
    margin-left: 5% !important;
    margin-top: 4% !important;
    margin-bottom: 1px !important;
    border-radius: 0px !important;
    background-color: rgba(250, 250, 250, 0.5) !important;
    border: 1px solid #3a3a3b !important;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    color: #080808 !important;
    font-size: 10px !important;
    width: 90% !important;
  } */

  /* .el-input__icon {
    width: 44px !important;
    text-align: justify !important;
    transition: all 0.3s !important;
    line-height: 65px !important;
    margin-right: 2px !important;
  } */

  .login .el-button.el-button--primary {
    margin: 0px !important;
    margin-bottom: 0px !important;
    transition: 1.1s !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    margin-left: 37% !important;
    padding: 11px !important;
  }

  .login .el-button.el-button--info {
    margin-top: 0px !important;
    transition: 1.1s !important;
    font-weight: 400 !important;
    font-size: 13px !important;
    margin-left: 20% !important;
    padding: 8px !important;
    height: 5vh !important;
    width: 13vw !important;
    text-align: center !important;
    border-radius: 30px !important;
    background-color: #1e75b3 !important;
  }

  .login .el-button--text {
    color: #0080ff !important;
    margin-top: 2% !important;
  }
}

/* ── Clinical Intelligence Core login redesign ── */
.cic-shell {
  display: flex !important;
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  font-family: "Inter", "Roboto", "Segoe UI", sans-serif;
}

/* ---- Left hero panel ---- */
.cic-hero {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  background: #0c0e12;
}

/* Soft right-edge feather — blends hero into the panel without a hard line */
.cic-hero::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 140px;
  background: linear-gradient(90deg, transparent 0%, rgba(228, 238, 252, 0.18) 100%);
  pointer-events: none;
  z-index: 3;
}

.cic-hero-bg,
.cic-hero-bg-img,
.cic-carousel-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cic-hero-bg {
  background-image: url("../assets/bg.jpeg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* no grayscale — let the photo's natural colors breathe */
}

.cic-hero-overlay {
  position: absolute;
  inset: 0;
  /* deep navy-blue tint instead of neutral black — ties into the brand palette.
     Kept lighter in the middle so the photo subject shows through clearly. */
  background: linear-gradient(
    170deg,
    rgba(8, 20, 55, 0.55) 0%,
    rgba(8, 20, 55, 0.28) 30%,
    rgba(8, 20, 55, 0.55) 62%,
    rgba(5, 14, 42, 0.82) 100%
  );
}

.cic-hero-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;
  box-sizing: border-box;
}

.cic-hero-spacer {
  flex: 1;
}

.cic-badge {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: #cde4ff;
  background: rgba(100, 180, 255, 0.15);
  border: 1px solid rgba(160, 210, 255, 0.4);
  border-radius: 9999px;
  padding: 6px 14px;
  backdrop-filter: blur(6px);
}

.cic-badge i {
  color: #a0c9ff;
  font-size: 13px;
}

.cic-hero-title {
  margin: 0 0 24px 0;
  font-size: 32px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #e2e2e7;
}

.cic-hero-accent {
  color: #a0c9ff;
}

.cic-feature-grid {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.cic-feature-card {
  flex: 1 1 0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  padding: 16px;
  backdrop-filter: blur(10px);
}

.cic-feature-card i {
  font-size: 18px !important;
  color: #a0c9ff !important;
  margin-bottom: 10px;
  display: block;
}

/* Higher specificity (0,2,1) so the card eye icon beats the global `i.el-icon-view`
   black rule no matter the source order. The password-toggle eye stays black since
   it is not inside .cic-feature-card. */
.cic-feature-card i.el-icon-view {
  color: #a0c9ff !important;
  font-size: 18px !important;
}

.cic-feature-card i.el-icon-view::before {
  color: #a0c9ff !important;
}

.cic-feature-card h4 {
  margin: 0 0 6px 0;
  font-size: 14px;
  font-weight: 600;
  color: #e2e2e7;
}

.cic-feature-card p {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #c2c7d1;
}

/* ---- Right login panel ---- */
.cic-panel {
  flex: 0 0 420px;
  min-width: 380px;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  /* Left edge starts with a very faint navy tint that fades quickly into the panel color —
     no hard cast, just a gentle colour handoff from the hero */
  background: linear-gradient(
    90deg,
    rgba(195, 215, 242, 0.32) 0%,
    #f4f7fd 70px,
    #eef3fb 100%
  );
}

.cic-panel-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.cic-panel-inner {
  width: 100%;
  max-width: 340px;
  margin: auto;
  /* extra top padding shifts the block below the visual midpoint */
  padding: 64px 0 32px;
  box-sizing: border-box;
}


.cic-brand {
  display: flex !important;
  align-items: center;
  justify-content: flex-start !important;
  height: auto !important;
  margin: 0 0 32px 0 !important;
  gap: 10px;
}

.cic-brand #img-01,
.cic-brand #img-02,
.cic-brand #img-03 {
  margin-top: 0 !important;
  height: auto !important;
  width: auto !important;
  display: flex;
  align-items: center;
  gap: 10px;
}

.cic-aikenist-logo {
  height: 32px;
  width: auto;
  object-fit: contain;
}

.cic-client-logo {
  max-width: 200px;
  max-height: 60px;
  object-fit: contain;
}

.cic-eyebrow {
  margin: 0 0 6px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8c919a;
}

.cic-title {
  margin: 0 0 28px 0;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #111317;
}

.cic-mfa-hint {
  font-size: 13.5px;
  color: #475569;
  line-height: 1.6;
  margin: 0 0 8px 0;
}

.cic-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.cic-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.cic-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #475569;
}

.cic-input-wrap {
  position: relative !important;
  width: 100%;
  box-sizing: border-box;
  height: 46px;
  display: flex !important;
  align-items: center !important;
  gap: 10px;
  padding: 0 13px !important;
  border: 1.5px solid #d4dff0;
  border-radius: 9px;
  background: #ffffff;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.cic-input-wrap:focus-within {
  border-color: #1a4f8a;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(15, 76, 129, 0.13);
}

.cic-input-icon {
  position: static !important;
  flex: 0 0 auto;
  display: flex !important;
  align-items: center !important;
  color: #94a3b8;
  font-size: 15px;
  line-height: 1 !important;
  pointer-events: none;
}

.cic-input {
  display: block !important;
  flex: 1 1 auto !important;
  height: 100% !important;
  width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  font-size: 14.5px !important;
  line-height: normal !important;
  color: #111317 !important;
  text-indent: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.cic-input:focus {
  outline: none !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.cic-input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
  -webkit-text-fill-color: #111317 !important;
}

.cic-clear,
.cic-eye {
  position: static !important;
  flex: 0 0 auto;
  top: auto !important;
  right: auto !important;
  transform: none !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  color: #94a3b8;
  cursor: pointer;
}

.cic-row-between {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: -4px;
}

.cic-forgot-link {
  font-size: 13px;
  color: #0f4c81;
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
}

.cic-forgot-link:hover {
  text-decoration: underline;
}

.cic-signup-row {
  margin: 12px 0 0;
  text-align: center;
  font-size: 13px;
  color: #64748b;
}

.cic-submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 9px;
  background: linear-gradient(135deg, #0d2d54 0%, #1a4f8a 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(10, 30, 80, 0.28);
  transition: box-shadow 0.18s ease, transform 0.06s ease;
}

.cic-submit-btn:hover {
  box-shadow: 0 6px 22px rgba(10, 30, 80, 0.4);
}

.cic-submit-btn:active {
  transform: scale(0.985);
  box-shadow: 0 2px 8px rgba(10, 30, 80, 0.25);
}

.cic-divider {
  height: 1px;
  background: #d4dff0;
  margin: 24px 0 16px;
}

.cic-utility-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

.cic-utility-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10.5px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  white-space: nowrap;
}

.cic-utility-link i {
  font-size: 11px;
  color: #64748b;
}

.cic-utility-link:hover {
  color: #0f4c81;
}

.cic-utility-link:hover i {
  color: #0f4c81;
}

.cic-trust-badges {
  display: flex;
  align-items: center;
  gap: 14px;
}

.cic-trust-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: #8c919a;
}

.cic-trust-badge i {
  font-size: 12px;
  color: #2d6197;
}

.cic-powered {
  margin-top: 20px !important;
  justify-content: flex-start !important;
  font-size: 13px !important;
  gap: 6px;
}

.cic-powered-text {
  font-style: normal !important;
  font-weight: 400 !important;
  color: #8c919a !important;
}

.cic-footer {
  border-top: 1px solid #d4dff0;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(210, 224, 245, 0.3);
}

.cic-footer-links {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.cic-footer-dot {
  color: #94a3b8;
  font-size: 10px;
  line-height: 1;
  flex-shrink: 0;
}

.cic-footer-link {
  font-size: 11px;
  color: #475569;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
}

.cic-footer-link:hover {
  color: #0f4c81;
  text-decoration: underline;
}

.cic-footer-plain {
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
}

.cic-footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.cic-footer-copy {
  font-size: 10.5px;
  color: #64748b;
  white-space: nowrap;
}

.cic-lang-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  font-size: 10.5px;
  font-weight: 500;
  color: #475569;
  white-space: nowrap;
}

.cic-lang-link:hover {
  color: #0f4c81;
}

@media only screen and (max-width: 760px) {
  .cic-hero {
    display: none;
  }
  .cic-panel {
    flex: 1 1 auto;
    max-width: 100%;
    min-width: 0;
  }
}

@media only screen and (max-width: 480px) {
  .cic-panel-inner {
    padding: 40px 20px 24px;
  }
  .cic-footer {
    flex-direction: column;
    align-items: flex-start;
    padding: 14px 20px;
  }
}
</style>
